// extracted by mini-css-extract-plugin
module.exports = {"input":"reset_input__QRkAO","label":"reset_label__12elY"};